import type { Rarity, Sport } from '@sorare/core/src/__generated__/globalTypes';
import { SEARCH_PARAMS } from '@sorare/core/src/components/search/InstantSearch/types';
import { buildFilterQuery } from '@sorare/core/src/components/search/InstantSearch/utils';
import { generateSportPath } from '@sorare/core/src/lib/routing/generateSportPath';

type Filters = {
  sport: Sport;
  rarity: Rarity;
  so5CompetitionSlug?: string;
};

export const getMarketShopUrl = (
  route: string,
  { sport, rarity, so5CompetitionSlug }: Filters
) =>
  `${generateSportPath(route, { sport })}?${buildFilterQuery({
    [SEARCH_PARAMS.RARITY]: rarity,
    [SEARCH_PARAMS.COMPETITION_ELIGIBILITY]: so5CompetitionSlug || undefined,
  })}`;
